import { useQuery } from "react-query";
import Angie from "~/utils/angie";
import { fetch } from "~/utils/fetch";

export const useNoteNavigation = (projectId, noteId, config) => {
  return useQuery({
    ...config,
    queryKey: ["note-navigation", projectId, noteId],
    queryFn: ({ signal }) => {
      return fetch({
        url: `${Angie.api_url}/projects/${projectId}/notes/${noteId}/navigation`,
        signal,
      });
    },
  });
};
